const getCropMaskCoords = (cropMask) => {
    const cropMaskCoords = cropMask['top_left'] || {};
    const x =
        cropMaskCoords.x || cropMaskCoords.x === 0 ? cropMaskCoords.x : '';
    const y =
        cropMaskCoords.y || cropMaskCoords.y === 0 ? cropMaskCoords.y : '';

    return { x, y };
};

/**
 * Retrieves relevant information from API image object
 * @param {string} fieldName Name of the field
 * @param {object} [apiImage] Image object info returned by the API
 * @returns {object} Object containing image information
 */
export const transformApiImageToImageField = (fieldName, apiImage = {}) => {
    // Note that `crop_mask` or `original` may be null in the JSON, so need to account for that.
    const originalInfo = apiImage.original || {};
    const cropMask = apiImage['crop_mask'] || {};

    const { x, y } = getCropMaskCoords(cropMask);

    return {
        [fieldName]: apiImage.id || '',
        [`${fieldName}Url`]: apiImage.url || '',
        [`${fieldName}OriginalUrl`]: originalInfo.url || '',
        [`${fieldName}CropX`]: x,
        [`${fieldName}CropY`]: y,
        [`${fieldName}CropWidth`]: cropMask.width || '',
        [`${fieldName}CropHeight`]: cropMask.height || '',
    };
};
